import React from 'react';
import moment from 'moment';
import uuidTime from 'uuid-time';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import { getIngestionList } from 'Workspace/Projects/store/actions.js';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const { projectId } = action;
  const workspaceIngestList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_PROJECT_INGEST_LIST,
    projectId,
  });
  if (workspaceIngestList.type === constants.RTM_PROJECT_INGEST_LIST_OK) {
    const ingestionSummaries = workspaceIngestList.response.ingestionSummaries;
    const ingestionList = ingestionSummaries?.sort(
      (a, b) => moment(uuidTime.v1(b.id)) - moment(uuidTime.v1(a.id))
    ) ?? [];
    yield put(getIngestionList(ingestionList));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceProjectIngestList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PROJECT_INGEST_LIST, catchErrors, sendRequest, connection);
}
